import { Grid } from '@mairistem/composants';
import { clamp } from 'lodash';
import React from 'react';
import { Pie, PieChart, Tooltip } from 'recharts';
import type PanelProps from '../../../interfaces/simulation/panelProps';

const SLICE_CHARGE_PERSONNEL = 'CHGPER';
const SLICE_DEPENSE_FONC = 'DEPFONC';

const CHART_LABEL = {
	[SLICE_CHARGE_PERSONNEL]: 'Charges Personnel',
	[SLICE_DEPENSE_FONC]: 'Dépenses fonctionnement',
};

const CHART_COLORS = {
	[SLICE_CHARGE_PERSONNEL]: '#ED7D31',
	[SLICE_DEPENSE_FONC]: '#5B9BD5',
};

const CHART_SIZE = 50;

const ChargePersonnel = ({ data }: PanelProps) => {
	const montantChargePersonnel = data?.montantChargePersonnel ?? 0;
	const depenseFonctionnement = data?.depenseReelFonctionnement ?? 0;
	const pourcentagePersonnel = clamp(
		depenseFonctionnement > 0
			? (montantChargePersonnel * 100) / depenseFonctionnement
			: 0,
		0,
		100,
	);

	return (
		<Grid>
			<Grid.Row>
				<Grid.Column width={16} className="bold indicateurTitle">
					Ratio frais de personnel
				</Grid.Column>
			</Grid.Row>
			<Grid.Row>
				<Grid.Column width={8} data-testid="pourcentagePersonnel">
					{pourcentagePersonnel.toFixed(2)} %
				</Grid.Column>
				<Grid.Column width={8}>
					<PieChart width={CHART_SIZE} height={CHART_SIZE}>
						<Tooltip
							allowEscapeViewBox={{ x: true, y: true }}
							formatter={(value: number, _name, entry) => [
								`${value} %`,
								CHART_LABEL[entry.payload.type],
							]}
							wrapperStyle={{ zIndex: 1000 }}
						/>
						<Pie
							data={[
								{
									type: SLICE_CHARGE_PERSONNEL,
									value: pourcentagePersonnel,
									fill: CHART_COLORS[SLICE_CHARGE_PERSONNEL],
								},
								{
									type: SLICE_DEPENSE_FONC,
									value: clamp(100 - pourcentagePersonnel, 0, 100),
									fill: CHART_COLORS[SLICE_DEPENSE_FONC],
								},
							]}
							dataKey="value"
							nameKey="type"
							cx="50%"
							cy="50%"
							outerRadius={CHART_SIZE / 2}
							isAnimationActive={false}
						/>
					</PieChart>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default ChargePersonnel;
